module.exports = __webpack_public_path__ + "media/images/hitfun/icon.trend.down-1323e056e7684898e9e69e8269ebfa4f.svg";